import type {
	SubscriptionPeriod,
	SubscriptionPlan,
} from "@/shared/components/PricingTable/types";

type Args = {
	onConfirm: (
		plan: SubscriptionPlan | null,
		period: SubscriptionPeriod,
	) => Promise<Error | undefined>;
	selectedPlan: SubscriptionPlan | null;
	newPeriod: SubscriptionPeriod;
	setError: (error: string | null) => void;
	setIsLoading: (isLoading: boolean) => void;
};
export async function handleOnConfirm(args: Args) {
	const { onConfirm, selectedPlan, newPeriod, setError, setIsLoading } = args;

	try {
		setIsLoading(true);
		const result = await onConfirm(selectedPlan, newPeriod);

		if (result instanceof Error) {
			setError("Something went wrong. Please try again later.");
		}
	} finally {
		setIsLoading(false);
	}
}
